// Rounds up to the nearest of the three 20-minute-apart boundaries starting at
// localSpeakingSlotMinutesOffset past the hour (0/20/40 for venues with a whole-hour UTC offset,
// e.g. 45/5/25 for Nepal's +5:45 offset).
export const roundEndTimeTo20Minutes = (
  timeString: string,
  localSpeakingSlotMinutesOffset = 0
): string => {
  const date = new Date(`1970-01-01T${timeString}`);
  const minutes = date.getMinutes();
  const minutesPastOffset = (((minutes - localSpeakingSlotMinutesOffset) % 60) + 60) % 60;

  if (minutesPastOffset >= 1 && minutesPastOffset <= 19) {
    date.setMinutes(minutes - minutesPastOffset + 20, 0, 0);
  } else if (minutesPastOffset >= 21 && minutesPastOffset <= 39) {
    date.setMinutes(minutes - minutesPastOffset + 40, 0, 0);
  } else if (minutesPastOffset >= 41 && minutesPastOffset <= 59) {
    date.setMinutes(minutes - minutesPastOffset + 60, 0, 0);
  }

  return date.toTimeString().substring(0, 8);
};
